import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Icon20 } from 'builder/components/Icon'
import { TooltipQuestion } from 'builder/components/Tooltip/variations'

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin: 0;
  align-items: center;

  ${Media.Phone`
    max-width: 145px;
  `}
`

export const Section = styled.div`
  display: flex;
  gap: 8px;
`

export const Progress = styled.div`
  width: 24px;
`

export const ProgressConatiner = styled.div<{ $percentage: number; $isDisabled?: boolean }>`
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $percentage, $isDisabled }) => css`
    background: conic-gradient(
      ${$isDisabled ? Colors.Neutral50 : Colors.Blue50} 0%,
      ${$isDisabled ? Colors.Neutral50 : Colors.Blue50} ${$percentage}%,
      ${$isDisabled ? Colors.Neutral20 : Colors.Blue20} ${$percentage}%,
      ${$isDisabled ? Colors.Neutral20 : Colors.Blue20} 100%
    );
  `}
`

export const ProgressBar = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${Colors.Neutral5};
`

export const TextSection = styled.div``
export const Header = styled.div<{ $isDisabled?: boolean }>`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: ${Colors.Neutral50};
    `};
`

export const SubHeader = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
  display: flex;
`

export const CompleteIcon = styled(Icon20.StatusOffer)`
  color: #25b869;
  margin-top: 2px;
`

export const Tooltip = styled(TooltipQuestion)`
  ${Media.Phone`
    & div > svg {
      color: ${Colors.Neutral90};
      right: -16px;
      left: auto;
    }
  `}
`
